import MCQIcon from '../../../../assets/icons/MCQ.svg';
import PracticalIcon from '../../../../assets/icons/Practical.svg';
import AssessmentHeadIcon from '../../../../assets/icons/AssessmentHead.svg';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import SharedService from '../../../../services/SharedService';

const AssessmentCard = ({ data }) => {
  const navigate = useNavigate();
  const handleOpenAssessment = (data) => {
    sessionStorage.setItem("assessmentId", data.id); // store id
    navigate(`/assessments/${SharedService.GenerateSlug(data.assessmentName)}`, { state: { id: data.id } })
  }
  return (
    <div className="card border-0 shadow p-3 p-lg-4 h-100"
      style={{ minHeight: "100px" }}
    >
      <div className="d-flex flex-row align-items-center gap-3" style={{ minHeight: '100px' }}>
        <div
          className="rounded-circle  d-flex justify-content-center align-items-center "
          style={{ width: "45px", height: "45px", flexShrink: 0 }}
        ><img
            src={AssessmentHeadIcon}
            alt="Assessment"
            className="w-4 h-4 hover:opacity-70 me-1"
          />
        </div>
        <h6 className="mb-0 lh-base">{data.assessmentName}</h6>
      </div>
      <hr className='mt-0 mb-3' />
      <div className="d-flex justify-content-between mb-4">
        <div className="fw-light" title='MCQ'>
          {data.mcq && <><img
            src={MCQIcon}
            alt="MCQ"
            className="w-4 h-4 hover:opacity-70 me-1 mb-1"
          /> MCQ</>}
        </div>
        <div className="fw-light" title='Practical'>
          {data.practical && <> <img
            src={PracticalIcon}
            alt="Practical"
            className="w-4 h-4 hover:opacity-70 me-1 mb-1"
          /> Practical</>}
        </div>
      </div>
      <div className="d-flex justify-content-center mb-1">
        <button

          className="px-5 py-2 rounded-pill btn btn-outline "
          style={{
            width: '100%'
          }}
          onClick={() => handleOpenAssessment(data)}
        >
          Open
        </button>
      </div>
    </div>
  )
}

export default AssessmentCard